module.exports = __webpack_public_path__ + "img/kaspr.eb3adcae.png";